import type { TElement, TSlateEditor, TText } from 'platejs';
import { KEYS } from 'platejs';

// Re-export Plate types for convenience
export type { TElement, TText };

export const ELEMENT_PARAGRAPH = KEYS.p;
export const ELEMENT_MENTION = KEYS.mention;
export const ELEMENT_MENTION_INPUT = KEYS.mentionInput;

export interface AlineMention extends TElement {
  children: TText[];
  type: typeof ELEMENT_MENTION;
  /** Email address */
  value: string;
}

export interface AlineMentionInput extends TElement {
  children: TText[];
  /** Usually '@' */
  trigger: string;
  type: typeof ELEMENT_MENTION_INPUT;
}

export type AlinePlateInlineElement = AlineMention | AlineMentionInput;

export type AlinePlateInline = AlinePlateInlineElement | TText;

export interface AlinePlateParagraph extends TElement {
  children: AlinePlateInline[];
  type: typeof ELEMENT_PARAGRAPH;
}

export type AlinePlateNode = AlinePlateParagraph | AlinePlateInline;

export type AlinePlateValue = AlinePlateParagraph[];

// Editor type - use editor.api methods (isInline, nodes) rather than direct Slate methods
export type AlinePlateEditor = TSlateEditor<AlinePlateValue>;
